// Small color-math helpers for deriving tints/shades from a company's brand
// color (from UseCompanyColors()), matching the fallback already used
// throughout the app for --gmb-primary (see Hero.jsx, CompanyView.jsx).
export const DEFAULT_BRAND = "#1B598E";

const hexToRgb = (hex) => {
  const clean = hex.replace("#", "");
  const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
  const value = parseInt(full, 16);
  return {
    r: Math.floor(value / 65536) % 256,
    g: Math.floor(value / 256) % 256,
    b: value % 256,
  };
};

export const brandRgba = (hex, alpha) => {
  const { r, g, b } = hexToRgb(hex || DEFAULT_BRAND);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const brandDarken = (hex, amount = 0.15) => {
  const { r, g, b } = hexToRgb(hex || DEFAULT_BRAND);
  const d = (c) => Math.max(0, Math.round(c * (1 - amount)));
  return `rgb(${d(r)}, ${d(g)}, ${d(b)})`;
};
